export enum AppName {
  Pricing = 'Pricing And Rating',
}
